import React, { useEffect, useState } from 'react';
import SingleCoinTitle from '../../../components/ui/TitleSection/Titles/SingleCoinTitle';
import { supportedBlockchains } from '../../../utils/supportedBlockchains';
import { assetData } from '../dummy-data';

const AssetTitle = ({ isLoading, asset }) => {
  const [titleSectionData, setTitleSectionData] = useState(null);

  useEffect(() => {
    if (!isLoading && asset) {
      setTitleSectionData({
        id: asset.id,
        logo: asset.image.large,
        name: asset.name,
        symbol: asset.symbol.toUpperCase(),
        tags: asset.categories
          .filter((category) => category !== null)
          .slice(0, 5),
        icons: assetData.icons,
        links: asset.links,
        platforms: supportedBlockchains(asset.platforms),
        blockchain:
          asset.platforms && Object.keys(asset.platforms).length
            ? asset.platforms
            : null,
      });
    }
  }, [asset, isLoading]);

  return (
    <SingleCoinTitle
      isAssetLoading={isLoading}
      singleCoinData={titleSectionData}
    />
  );
};

export default AssetTitle;
